import { useMemo } from "react";
import { useBiddingProgramActiveAdCounts } from "../../../../modules/programs/api/useBiddingProgramActiveAdCounts";
import { type Program } from "../../../../zodios/apiDefinitions/api/programs";

export type ProgramWithActiveAds = Program & { active_ad_type_count?: number };

// Joins each bidding program's active advertisement count into its row, for AdvertisingProgramsTable's
// showActiveAds. Joined rather than read by the accessor: rows cache accessor values, so an accessor
// reading the stats would keep the zeros from before they loaded.
export const useProgramsWithActiveAdCounts = (programs: Program[] | undefined): ProgramWithActiveAds[] | undefined => {
  const { data: activeAdCounts } = useBiddingProgramActiveAdCounts();

  return useMemo(
    () => programs?.map((p) => ({ ...p, active_ad_type_count: activeAdCounts?.[p.id] ?? 0 })),
    [programs, activeAdCounts],
  );
};
